// Libs
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import { getListMasterData } from '~/thunks/masterData/masterDataThunk';

export interface IMasterDataState {
  isRefreshMasterDataList: boolean;
}

export const initialState: IMasterDataState = {
  isRefreshMasterDataList: false,
};

const masterDataSlice = createSlice({
  name: 'masterData',
  initialState,
  reducers: {
    setRefreshCategoryList(state, action: PayloadAction<boolean>) {
      state.isRefreshMasterDataList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list master data
    builder
      .addCase(getListMasterData.pending, (_state) => {})
      .addCase(getListMasterData.fulfilled, (_state) => {})
      .addCase(getListMasterData.rejected, (_state) => {});
  },
});

// Action
export const masterDataActions = masterDataSlice.actions;

// Selectors
export const selectIsRefreshMasterDataList = (state: RootState) => state.masterData.isRefreshMasterDataList;

// Reducer
const masterDataReducer = masterDataSlice.reducer;
export default masterDataReducer;
